import { jsx } from "react/jsx-runtime";
import { CreditWorthinessTooltip } from "../../../../components/credit-worthiness-tooltip/credit-worthiness-tooltip.js";
import { useLabels } from "../../labels.provider.js";
import { PatientCreditworthinessStatus } from "../../patient-today-list.types.js";
import { StyledIconButton, StyledCreditWorthinessIcon } from "./credit-worthiness-status.styles.js";
import "@mui/material/Button/index.js";
import "../../../../components/credit-worthiness-tooltip/credit-worthiness-tooltip.styles.js";
import "@mui/material";
import "@mui/material/styles";
import "react";
import "../../assets/icons/CreditWorthinessIcon.js";
const CreditworthinessStatus = ({ status = PatientCreditworthinessStatus.UNKNOWN, limit, enabled }) => {
  const { labels } = useLabels();
  if (!enabled) {
    return null;
  }
  const handleClick = (e) => {
    e.stopPropagation();
  };
  return /* @__PURE__ */ jsx(
    CreditWorthinessTooltip,
    {
      placement: "top",
      onClick: handleClick,
      creditWorthinessLabels: labels == null ? void 0 : labels.creditWorthiness,
      creditWorthinessData: {
        status,
        factoringCompany: "",
        limit,
        availableAmount: ""
      },
      children: /* @__PURE__ */ jsx(StyledIconButton, { status, children: /* @__PURE__ */ jsx(StyledCreditWorthinessIcon, { status }) })
    }
  );
};
export {
  CreditworthinessStatus as default
};
